import {
  faArrowAltToBottom,
  faArrowAltToTop,
  faTag,
} from '@fortawesome/pro-solid-svg-icons';
import { Outlet } from 'react-router';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import {
  MY_SORARE_OFFERS_RECEIVED,
  MY_SORARE_OFFERS_SALES,
  MY_SORARE_OFFERS_SENT,
} from '@sorare/core/src/constants/__generated__/routes';
import { MySorareSubTabsLayout } from '@sorare/marketplace/src/components/mySorare/MySorareSubTabsLayout';
import { TITLES } from '@sorare/marketplace/src/components/mySorare/common/pages';

const tabsValues = [
  {
    to: MY_SORARE_OFFERS_RECEIVED,
    label: TITLES.offers_received,
    icon: (
      <FontAwesomeIcon
        color="var(--c-onBase-success)"
        icon={faArrowAltToBottom}
      />
    ),
  },
  {
    to: MY_SORARE_OFFERS_SENT,
    label: TITLES.offers_sent,
    icon: <FontAwesomeIcon color="var(--c-red-400)" icon={faArrowAltToTop} />,
  },
  {
    to: MY_SORARE_OFFERS_SALES,
    label: TITLES.sales,
    icon: <FontAwesomeIcon color="var(--c-green-400)" icon={faTag} />,
  },
];

const MySorareOffersLayout = () => {
  return (
    <MySorareSubTabsLayout tabs={tabsValues}>
      <Outlet />
    </MySorareSubTabsLayout>
  );
};
export default MySorareOffersLayout;
